import React from 'react';
import type { RicosTiptapContextValue } from 'ricos-types';

export const EditorPropsContext = React.createContext<Record<string, any> | null>(null);

export const RicosTiptapContext = React.createContext<RicosTiptapContextValue>(
  null as unknown as RicosTiptapContextValue
);
